import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { NOTICE } from '../../content/texts.nl';
import { SheetDragDirective } from '../touch/sheet-drag.directive';
import { SwipeDirective } from '../touch/swipe.directive';
import { IconComponent } from '../ui/icon.component';
import { NoticeService } from './notice.service';

/**
 * The message bar at the bottom of the screen, placed once in the app root. On a phone it sits just above the
 * tab bar, where the thumb and the eye already are; on a desktop at the bottom centre of the content.
 *
 * The live region is always in the page and only its content changes: a screen reader announces text that
 * appears in an existing region, not a region that appears with its text already in it.
 *
 * A finger can flick it away downwards (appSheetDrag on the text) or sideways (appSwipe on the bar); the
 * close button does the same for everyone else.
 */
@Component({
  selector: 'app-notice',
  standalone: true,
  imports: [IconComponent, SheetDragDirective, SwipeDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './notice.component.html',
})
export class NoticeComponent {
  protected readonly notices = inject(NoticeService);
  protected readonly texts = NOTICE;

  /** As a list of one, so a new notice is a new element and slides in again. */
  protected readonly shown = computed(() => {
    const notice = this.notices.notice();

    return notice === null ? [] : [notice];
  });
}
